import { keyframes } from 'tss-react';

const pulseRingKeyframes = keyframes({
    '0%': { opacity: 0.75, transform: 'scale(1)' },
    '100%': { opacity: 0, transform: 'scale(1.75)' },
});

export default theme => ({
    root: {
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    logo: {
        display: 'block',
        position: 'relative',
        zIndex: 1,
    },
    pulse1: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        borderRadius: '50%',
        border: `1px solid ${theme.palette.primary?.main || '#6B38FB'}`,
        opacity: 0,
        animation: `${pulseRingKeyframes} 2.4s ease-out infinite`,
    },
    pulse2: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        borderRadius: '50%',
        border: `1px solid ${theme.palette.primary?.main || '#6B38FB'}`,
        opacity: 0,
        animation: `${pulseRingKeyframes} 2.4s ease-out 0.8s infinite`,
    },
    pulse3: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        borderRadius: '50%',
        border: `1px solid ${theme.palette.primary?.main || '#6B38FB'}`,
        opacity: 0,
        animation: `${pulseRingKeyframes} 2.4s ease-out 1.6s infinite`,
    },
});
